// extracted by mini-css-extract-plugin
export default {"faq":"FaqDialog_faq__ZKe5O"};